<template>
  <div class="flex flex-col justify-start items-start gap-2">
    <NText class="whitespace-pre-line" variant="caption2">
      <i18n-t scope="global" keypath="withdrawal.payFastDescription" tag="span">
        <template #roof>
          <NText variant="caption2" weight="bold">
            {{ t('withdrawal.payFastDescription_roof') }}
          </NText>
        </template>
      </i18n-t>
    </NText>

    <div class="flex flex-col gap-2">
      <NText class="whitespace-pre-line" variant="caption2">
        {{ t('withdrawal.payFastDescriptionPoint') }}
      </NText>

      <ul class="list-['•_'] list-inside leading-5 ps-2">
        <li>
          <NText class="align-middle" variant="caption2">
            {{ t('withdrawal.payFastDescriptionPointFirst') }}
          </NText>
        </li>
        <li>
          <NText class="align-middle" variant="caption2">
            {{ t('withdrawal.payFastDescriptionPointSecond') }}
          </NText>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
